import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Trash2 } from "lucide-react";
import { getCart, updateQuantity, removeFromCart, cartTotal } from "@/lib/cart";

export default function Cart() {
  const [cart, setCart] = useState(getCart());

  useEffect(() => {
    const sync = () => setCart(getCart());
    window.addEventListener("cartUpdated", sync);
    return () => window.removeEventListener("cartUpdated", sync);
  }, []);

  if (cart.length === 0) {
    return (
      <div className="py-16 text-center">
        <h1 className="text-2xl font-extrabold">Your cart is empty</h1>
        <Link to="/" className="btn-primary mt-4">
          Browse Kits
        </Link>
      </div>
    );
  }

  return (
    <div>
      <h1 className="mb-6 text-2xl font-extrabold">Your Cart</h1>
      <div className="space-y-3">
        {cart.map((item) => (
          <div
            key={item.product_id}
            className="card flex items-center justify-between p-4"
          >
            <div>
              <p className="font-bold">{item.name}</p>
              <p className="text-sm text-gray-500">${item.price.toFixed(2)} each</p>
            </div>
            <div className="flex items-center gap-4">
              <input
                type="number"
                min="1"
                className="input w-20 text-center"
                value={item.quantity}
                onChange={(e) =>
                  updateQuantity(
                    item.product_id,
                    Math.max(1, parseInt(e.target.value || "1", 10)),
                  )
                }
              />
              <span className="w-20 text-right font-bold">
                ${(item.price * item.quantity).toFixed(2)}
              </span>
              <button
                onClick={() => removeFromCart(item.product_id)}
                className="text-gray-400 hover:text-red-600"
                aria-label="Remove"
              >
                <Trash2 size={18} />
              </button>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 flex items-center justify-end gap-6">
        <span className="text-lg">
          Total:{" "}
          <span className="text-2xl font-extrabold text-fairway-700">
            ${cartTotal().toFixed(2)}
          </span>
        </span>
        <Link to="/checkout" className="btn-primary">
          Proceed to Checkout
        </Link>
      </div>
    </div>
  );
}
